/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedRepository
 */
export interface PatchedRepository {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The unique_id of an organisation
   */
  organisation?: string;
  /**
   * do not change
   */
  slug?: string;
  /**
   *
   */
  readonly revision?: Array<string>;
}

/**
 * Check if a given object implements the PatchedRepository interface.
 */
export function instanceOfPatchedRepository(value: object): value is PatchedRepository {
  return true;
}

export function PatchedRepositoryFromJSON(json: any): PatchedRepository {
  return PatchedRepositoryFromJSONTyped(json, false);
}

export function PatchedRepositoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedRepository {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    organisation: json["organisation"] == null ? undefined : json["organisation"],
    slug: json["slug"] == null ? undefined : json["slug"],
    revision: json["revision"] == null ? undefined : json["revision"],
  };
}

export function PatchedRepositoryToJSON(json: any): PatchedRepository {
  return PatchedRepositoryToJSONTyped(json, false);
}

export function PatchedRepositoryToJSONTyped(
  value?: Omit<PatchedRepository, "url" | "id" | "revision"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisation: value["organisation"],
    slug: value["slug"],
  };
}
